/** Mirrors internal.hr_adverse_action_is_checker (20413000000067).
 * Review discovery does not grant maker, worker-scope or decision authority.
 */
export const ADVERSE_ACTION_REVIEWER_ROLES = [
  'HR_DIRECTOR',
  'TENANT_ADMIN',
  'OWNER',
  'CEO',
] as const;
